export default "__VITE_ASSET__CsqQdH2h__"